module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"da":{"price":{"business-net":"net"}},"de":{"version":1,"price":{"business-net":"Netto"}},"en":{"price":{"business-net":"Net"}},"fr":{"price":{"business-net":"rapporter"}},"nl":{"price":{"business-net":"Netto"}}}')
  delete Component.options._Ctor
}
